import { formatLawFirmSearchLabel, isLawFirmUnverified, isLawFirmVerified } from '../../lib/lawFirmSearchOptions'
import classes from './LawFirmSearchOptionLabel.module.css'

function LawFirmLabelText({ code, name, label }) {
    const firmName = name ?? ''
    if (code) {
        return (
            <>
                <span className={classes.code}>{code}</span>
                <span className={classes.separator}> - </span>
                <span className={classes.name}>{firmName || label}</span>
            </>
        )
    }

    return <>{label || firmName}</>
}

/**
 * Renders look-ahead / match-list text with a status dot:
 * red = Unverified, green = Verified. Law firm code is bold when present.
 * Full label on hover via title (works in react-select menus and create modal lists).
 */
export default function LawFirmSearchOptionLabel({ label, code, name, verified, showDot = true }) {
    const fullLabel = label || formatLawFirmSearchLabel({ code, name })

    const labelText = (
        <span className={classes.text} title={fullLabel}>
            <LawFirmLabelText code={code} name={name} label={label} />
        </span>
    )

    if (!showDot) {
        return (
            <span className={classes.option_label}>
                {labelText}
            </span>
        )
    }

    const unverified = isLawFirmUnverified(verified)
    const verifiedFirm = isLawFirmVerified(verified)
    const statusTooltip = unverified
        ? 'Law firm is not verified'
        : verifiedFirm
            ? 'Law firm is verified'
            : 'Law firm verification status unknown'
    const dotClass = unverified
        ? classes.not_verified
        : verifiedFirm
            ? classes.verified
            : classes.status_unknown

    return (
        <span className={classes.option_label}>
            <span className={dotClass} title={statusTooltip} aria-label={statusTooltip} />
            {labelText}
        </span>
    )
}
